// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    '../../../utils/FormMessage',
    'jquery',
    'underscore',
    'backbone',
    '../models/InterfaceParameterCollection',
    '../../app/views/UploadView',
], (Globals, FormMessage, $, _, Backbone, InterfaceParameterCollection, UploadView) => {
    const MyUploadView = Backbone.View.extend({
        initialize(options) {
            this.options = options || [];
            this.urlUpload = Globals.baseUrl + 'interfaces/upload';
        },
        render() {
            const view = this;
            const { model } = view;
            view.uploadView = new UploadView({
                title: $._('interface.upload.title'),
                yesString: $._('interface.upload.yes'),
                multiupload: false,
                formData: { id: model.id },
                url: this.urlUpload,
                done() {
                    console.log('success');
                    // var formMessage = new FormMessage(data);
                    view.uploadView.remove();
                    if (_.isFunction(view.options.success)) {
                        view.options.success();
                    }
                },
                yesFunc() {
                    view.setElement($('.modalMessage'));
                    view.uploadReport();
                }
            });
        },
        uploadReport() {
            const view = this;
            const { model } = view;
            model.setForm(view.$('form'));
            if (model.form != null) {
                if (_.isUndefined(model.validate())) {
                    model.form.attr('action', view.urlUpload);
                    model.form.ajaxForm({
                        url: view.urlUpload,
                        data: { id: model.id },
                        dataType: 'json',
                        success() {
                            console.log('success');
                            // new FormMessage(data);
                            view.uploadView.remove();
                            if (_.isFunction(view.options.success)) {
                                view.options.success();
                            }
                        }
                    });
                    model.form.submit();
                }
            }
        }
    });
    return MyUploadView;
});



// WEBPACK FOOTER //
// ./src/components/interface/views/UploadView.js